import prepareComponent from "@bluframe/grapple/prepareComponent"
import { ChangeEventHandler } from "react"

import Text from "./Text"

export interface Props {
  disabled?: boolean
  hasValid?: boolean
  id?: string
  isValid?: boolean
  label: string
  name: string

  onChange?: (text: string) => void
  text?: number | string
}

export interface ComponentProps extends Omit<Props, "onChange"> {
  onChange: ChangeEventHandler<HTMLInputElement>
}

const usePrepareComponent = (props: Props): ComponentProps => {
  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    if (props.onChange) {
      props.onChange(event.target.value)
    }
  }

  return {
    ...props,
    onChange
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Text
)
